const RGB_STRING_PARSE_ERROR = 'Failed parsing RGB';
export function rgbStringToArray(input: string): [number, number, number] | {
  error: String;
} {
  if (!input.startsWith('rgb(') || !input.endsWith(')')) {
    return {
      error: RGB_STRING_PARSE_ERROR
    };
  }
  const cleanedString = input.replace('rgb(', '').replace(')', '').split(',');
  if (cleanedString.length > 3) {
    return {
      error: RGB_STRING_PARSE_ERROR
    };
  }
  const r = Number(cleanedString[0]);
  const g = Number(cleanedString[1]);
  const b = Number(cleanedString[2]);
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
    return {
      error: RGB_STRING_PARSE_ERROR
    };
  }
  return [r, g, b];
}